var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVerse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 154,
    height: 38,
    viewBox: "0 0 154 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.078,
    y1: 0.104,
    x2: 0.629,
    y2: 0.883,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e56d72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc3a52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc3851"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Logo-Verse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-Verse",
    clipPath: "url(#clip-Logo-Verse)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-2 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon-Verse",
    d: "M46.772,9.875a10.346,10.346,0,0,0-17.282-7.2c-.127.115-.252.234-.37.352L23.391,8.76,17.662,3.031c-.119-.118-.243-.237-.37-.352A10.347,10.347,0,0,0,2.354,16.918l.1.115a10.015,10.015,0,0,0,.76,1.012L16.161,33.179a9.515,9.515,0,0,0,14.46,0L43.57,18.045a10.008,10.008,0,0,0,.76-1.012l.1-.116a10.319,10.319,0,0,0,2.344-7.043m-3.987,5.631-.028-.02c-.17.206-.35.4-.536.591a8.191,8.191,0,0,1-11.57,0l-5.7-5.7.029-.029-.056-.056,5.729-5.729c.093-.093.192-.188.294-.279a8.169,8.169,0,0,1,11.276.279h0a8.144,8.144,0,0,1,.564,10.945",
    transform: "translate(4 7)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(59.761 15.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1102.8,363.057V343.871h2.753v2.763c1.3-1.689,3.914-2.955,7.981-2.763V346.6c-4.988-.038-7.981,2.609-7.981,6.485v9.977Z",
    transform: "translate(-1058.972 -343.767)",
    fill: "#dc3851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M657.235,218.158a7.1,7.1,0,0,1-12.046-3.615h16.677a9.8,9.8,0,1,0-1.257,3.615Zm-5.073-12.066a7.114,7.114,0,0,1,6.973,5.755H645.189A7.114,7.114,0,0,1,652.162,206.091Z",
    transform: "translate(-622.164 -203.395)",
    fill: "#dc3851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M657.235,218.158a7.1,7.1,0,0,1-12.046-3.615h16.677a9.8,9.8,0,1,0-1.257,3.615Zm-5.073-12.066a7.114,7.114,0,0,1,6.973,5.755H645.189A7.114,7.114,0,0,1,652.162,206.091Z",
    transform: "translate(-567.181 -203.395)",
    fill: "#dc3851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1251.67,357.169a4.241,4.241,0,0,0-.943-2.977,6.08,6.08,0,0,0-2.488-1.571,28.281,28.281,0,0,0-3.3-.923,13.121,13.121,0,0,1-3.309-1.124,2.2,2.2,0,0,1-1.32-1.993,2.523,2.523,0,0,1,1.022-2.086,4.469,4.469,0,0,1,2.784-.771,4.661,4.661,0,0,1,2.937.867,3.487,3.487,0,0,1,1.291,2.21h2.683a5.71,5.71,0,0,0-2.1-3.852,7.556,7.556,0,0,0-4.774-1.45,7.235,7.235,0,0,0-4.841,1.52,4.877,4.877,0,0,0-1.76,3.866,3.551,3.551,0,0,0,.958,2.589,6.7,6.7,0,0,0,2.459,1.559,19.39,19.39,0,0,0,3,.863,16.761,16.761,0,0,1,3.528,1.043,2.482,2.482,0,0,1,1.371,2.493,2.887,2.887,0,0,1-1.027,2.207,4.576,4.576,0,0,1-3.121.915,5.38,5.38,0,0,1-3.59-1.138,4.788,4.788,0,0,1-1.612-2.508h-2.805a6.419,6.419,0,0,0,2.491,4.21,8.809,8.809,0,0,0,5.478,1.661,7.76,7.76,0,0,0,5.147-1.6A4.883,4.883,0,0,0,1251.67,357.169Z",
    transform: "translate(-1179.803 -343.5)",
    fill: "#dc3851"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M359.411,502.192l-7.746-19.171h3.161l6.239,16.04,6.278-16.04h3.084l-7.746,19.171Z",
    transform: "translate(-351.665 -483.022)",
    fill: "#dc3851"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVerse);
export default __webpack_public_path__ + "static/media/Logo-Verse.1ddb4899461c6d3bd5e9cd8da2c35cc8.svg";
export { ForwardRef as ReactComponent };